import { Environments } from "./constants";

// Extend the Window interface to include AvaAppConfig
declare global {
    interface Window {
        AvaAppConfig?: {
            env?: Environments;
            hostnames?: {
                identity?: string;
                avatax?: string;
                avaApp?: string;
            };
            [key: string]: unknown;
        };
    }
}

const isOneWebDomainRuntime = (): boolean => {
    return !!window.AvaAppConfig;
};

export default isOneWebDomainRuntime;
